import { Dependencies, FileContent, FileContentFactory, Survey } from ".."

export interface ModifySurvey {
    isDraft: boolean
    isActive: boolean
    isDeleted: boolean
    names: {
        [key: string]: string
    }
    descriptions: {
        [key: string]: string
    }
    image: FileContent
    link: string
    startDate: string
    endDate: string
    dependencies: Dependencies | null
}

export class ModifySurveyFactory {
    static create(): ModifySurvey {
        return {
            isDraft: false,
            isActive: false,
            isDeleted: false,
            names: {},
            descriptions: {},
            image: FileContentFactory.create(),
            link: "",
            startDate: "",
            endDate: "",
            dependencies: null,
        }
    }

    static from(survey: Survey): ModifySurvey {
        const modifySurvey: ModifySurvey = JSON.parse(
            JSON.stringify({
                isDraft: survey.isDraft,
                isActive: survey.isActive,
                isDeleted: survey.isDeleted,
                names: survey.names,
                descriptions: survey.descriptions,
                image: FileContentFactory.fromUrl(survey.imageUrl ?? ""),
                link: survey.link ?? "",
                startDate: survey.startDate ?? "",
                endDate: survey.endDate ?? "",
                dependencies: survey.dependencies ?? null,
            })
        )
        return modifySurvey
    }
}
